import { get } from 'lodash';
import * as React from 'react';
import { gamification } from '../../api/event';
import { nonPiletInstances, PILET_NAMES } from '../../configs/config';
import { STORAGE_KEYS } from '../../Utils/constants';
import { parseQueryParams } from '../../Utils/utils';
import { Loading } from '../UI/loading';

const ProfileSDK = () => {
  const [d, setD] = React.useState({
    isLoading: true
  });

  const hideLoading = () => {
    setD({
      ...d,
      isLoading: false
    });
  };

  const params = parseQueryParams(get(location, 'search', {}));
  const navigate = get(params, 'navigate', 'Home');
  const [profileApp] = nonPiletInstances.filter(
    ({ appName }) => appName === PILET_NAMES.PROFILESDK
  );
  const pathname = location.pathname;
  const [, , nextScreen] = pathname.split('/');
  const frame: any = document.getElementsByTagName('iframe');
  let loansData = {};
  const dashboardData = localStorage.getItem('DASHBOARD_DATA');
  let authData = {};

  try {
    const parsedDashboardData = JSON.parse(dashboardData);
    loansData = {
      authData: JSON.stringify(loansData),
      dashboardData: parsedDashboardData,
      customDomain: process.env.CUSTOM_DOMAIN
    };

    authData = {
      authData: localStorage.getItem(STORAGE_KEYS.AUTH_CONFIG),
      dashboardData: parsedDashboardData ? parsedDashboardData.data : {},
      customDomain: process.env.CUSTOM_DOMAIN,
      navigate
    };
  } catch (e) {
    console.warn('error parsing dashboarddata', e);
  }
  React.useEffect(() => {
    window.addEventListener('message', (event) => {
      const action = get(event, 'data.action', '');

      if (action === 'get_detail') {
        gamification({
          name: `OPEN_${PILET_NAMES.PROFILESDK}`,
          type: 'OPEN_APP'
        });
        setTimeout(() => {
          const [container] = frame;
          if (container.contentWindow) {
            container.contentWindow.postMessage(
              {
                call: 'sendValue',
                value: authData
              },
              '*'
            );
          }
        }, 3000);
      } else if (action === 'close_app') {
        history.pushState('', '', nextScreen ? `/${nextScreen}` : '/');
        var popStateEvent = new PopStateEvent('popstate', {});
        dispatchEvent(popStateEvent);
        gamification({
          name: `CLOSE_${PILET_NAMES.PROFILESDK}`,
          type: 'CLOSE_APP'
        });
      }
    });
  }, []);
  return (
    <div
      style={{
        width: '100vw',
        height: '100vh'
      }}
    >
      {d.isLoading && <Loading />}
      <iframe
        style={{ height: '100%', width: '100%' }}
        onLoad={hideLoading}
        src={profileApp.url}
      ></iframe>
    </div>
  );
};

export default ProfileSDK;
